export const branch = {
  value: {
    yes: 'Yes',
    no: 'No',
    dnk: 'IDontKnow',
  },
  label: {
    yes: 'Yes',
    no: 'No',
    dnk: "I don't know",
    or: 'Or',
  },
  confirmation:
    'Are you sure you would like to change your answer? This will remove any data currently entered.',
  additionalEntry: {
    title: 'Invalid Selection',
    message: 'Section requires "No" value for additional entries'
  }
};
